import Vue from 'vue';

export default {
  login({ username, password }) {
    return Vue.axios.post(
      'https://9pt0wza7da.execute-api.us-east-1.amazonaws.com/development/login',
      {
        username,
        password,
      },
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/auth.js